export default __webpack_public_path__ + "static/media/logoSM.6d014202.svg";